import { render, staticRenderFns } from "./UpdateBaykedCustomer.vue?vue&type=template&id=0c15385a&scoped=true&"
import script from "./UpdateBaykedCustomer.vue?vue&type=script&lang=js&"
export * from "./UpdateBaykedCustomer.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBaykedCustomer.vue?vue&type=style&index=0&id=0c15385a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c15385a",
  null
  
)

export default component.exports